module.exports = __webpack_public_path__ + "static/banner3-5200719544b216f01c4c900ce9682cde.jpg";